import React from 'react';

import { useCommon } from '../../store/CommonContext';
import { PRIMARY_COLOR } from '../constants/style-constants';

import './Title.css';

interface Props {
  text: string | null;
  children?: React.ReactElement | null;
  additionalClasses?: string;
}

const Title: React.FC<Props> = props => {
  const { text, children, additionalClasses } = props;
  const {
    state: { configuration },
  } = useCommon();

  return (
    <h1
      className={`ui-widget-title ${additionalClasses}`}
      style={configuration?.primaryColor ? { color: configuration.primaryColor as string } : undefined}
    >
      {children || text}
    </h1>
  );
};

export default Title;
